// src/services/apiUtils.ts
import { api } from './api';

/**
 * 공통 GET 요청 함수
 */
export const apiGet = async <T, P = Record<string, unknown>>(endpoint: string, params?: P): Promise<T> => {
  const response = await api.get(endpoint, { params });
  return response.data;
};

/**
 * 공통 POST 요청 함수
 */
export const apiPost = async <T, D = Record<string, unknown>>(endpoint: string, data?: D): Promise<T> => {
  const response = await api.post(endpoint, data);
  return response.data;
};

/**
 * 공통 PATCH 요청 함수
 */
export const apiPatch = async <T, D = Record<string, unknown>>(endpoint: string, data?: D): Promise<T> => {
  const response = await api.patch(endpoint, data);
  return response.data;
};

/**
 * 공통 PUT 요청 함수
 */
export const apiPut = async <T, D = Record<string, unknown>>(endpoint: string, data?: D): Promise<T> => {
  const response = await api.put(endpoint, data);
  return response.data;
};

/**
 * 공통 DELETE 요청 함수
 */
export const apiDelete = async <T, D = Record<string, unknown>>(endpoint: string, data?: D): Promise<T> => {
  const response = await api.delete(endpoint, { data });
  return response.data;
};

/**
 * 파일 업로드 요청 함수
 */
export const apiUpload = async <T>(
  endpoint: string,
  file: File,
  additionalData?: Record<string, string | Blob>,
): Promise<T> => {
  const formData = new FormData();
  formData.append('file', file);

  if (additionalData) {
    Object.entries(additionalData).forEach(([key, value]) => {
      formData.append(key, value);
    });
  }

  const response = await api.post(endpoint, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return response.data;
};
